(ns iris.analytics.route-data
  (:require
   [iris.analytics.events :as analytics-events]))


(defn analytics-query-params [db _route]
  (when-let [ws (:ws db)]
    {:report (get-in db [:analytics :report] "realtime")
     :ws     ws}))


(defn analytics-load-key [query-params]
  query-params)


(defn analytics-effects [{:keys [report ws]}]
  (if (= report "archive")
    [[::analytics-events/get-analytics-tables ws]
     [::analytics-events/get-total-report ws]]
    [[::analytics-events/get-analytics-report report ws]
     [::analytics-events/get-total-report ws]]))


(def panel-loaders
  {:analytics-panel
   {:params-fn   analytics-query-params
    :load-key-fn analytics-load-key
    :effects-fn  analytics-effects}})
